export const byodServiceCode = ['6401', 'EM6401', '6412'];
export const wowManagedStb = ['UIW4020'];
export const CUSTOMER_BYOD_TEXT = "Customer BYOD Placeholder";
export const removedStatus = "remove";
export const addStatus = "add";
export const currentPortTypeTvPlus = ['IPVE'];



// WEBPACK FOOTER //
// ./src/constants/byodCodesConfig.js